import React from "react";
import { useParams } from 'react-router-dom';
import { Box, Drawer, Accordion, ActionIcon, Group, Text, Collapse } from '@mantine/core';
import { IconMessageChatbot, IconChevronDown, IconChevronUp, IconArrowLeft } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';

import { useLoginContext } from "../../context/loginContext";

import { utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { canAccessModifyStepNota } from "../../utils/accessing";

import ImageLightBox2 from "../../components/general/ImageLightBox2";

import VideoPlayerModal from "../../components/general/VideoPlayerModal";
import StepNota from "../../components/utilities/StepNota";
import StepNotaDibatalkan from "../../components/utilities/StepNotaDibatalkan";
import StepPengerjaan from "../../components/utilities/StepPengerjaan";
import HistoryProjectCustomer from "../../components/utilities/HistoryProjectCustomer";
import FeedbackDrawer from "../home/feedback/FeedbackDrawer";

const ProjectPengerjaanSelected = ({
  fnRefreshNotaIndex,
  fnSuccessTakesThisProject,
  fnCloseDrawer,
  stateData
}) => {

  const { URI1 } = useParams();
  const { loginContext } = useLoginContext();

  const [collapseNotaOpened, collapseNotaToggle] = useDisclosure(false);

  const utilsRef = React.useRef({
    projectProcess: utils.projectProcess.pengerjaan.value,
    projectIsCancel: '0',
    userAccess: [
      // role.owner.subLevel.owner.slugSubLevel,
      // role.admin.subLevel.admin_kepala.slugSubLevel,
      // role.admin.subLevel.admin_staf.slugSubLevel,
    ]
  })

  const [data, setData] = React.useState({
    imageLightboxImages: '',
    imageLightboxTitle: '',
    imageLightboxIndex: '',
    imageLightboxFieldName: '',
    imageLightboxShow: false,

    feedbackModal: false,

    mediaURL: '',
    mediaTitle: '',
    mediaShow: false,

    counterHistoryProject: '',
    triggerRefreshHistory: new Date(),
  });

  const fnCounter = React.useCallback((val) => {
    setData(d => ({ ...d, counterHistoryProject: val }))
  }, [])

  return (
    <React.Fragment>
      <Drawer
        opened={URI1}
        onClose={fnCloseDrawer}
        withCloseButton={false}
        position="left"
        closeOnClickOutside={true}
        title={
          <Group noWrap spacing='xs'>
            <ActionIcon
              size='lg'
              variant="light"
              radius='xl'
              color="blue"
              onClick={fnCloseDrawer}
            >
              <IconArrowLeft size='1.25rem' stroke={1.5} />
            </ActionIcon>

            <Group position='apart' style={{ width: '100%' }}>
              <Text>Pengerjaan</Text>
              <ActionIcon
                size='lg'
                variant="light"
                color="green"
                radius='xl'
                onClick={() => setData(d => ({ ...d, feedbackModal: true }))}
              >
                <IconMessageChatbot size='1.25rem' stroke={1.25} />
              </ActionIcon>
            </Group>
          </Group>
        }
        size='md'

        styles={() => ({
          title: {
            fontWeight: 'bold',
            textTransform: 'uppercase',
            width: '100%',
          }
        })}
      >
        <Box
          mb='sm'

          sx={(tema) => ({
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: tema.colorScheme === 'light' ? tema.colors.gray[3] : tema.colors.dark[4],
            borderRadius: tema.radius.sm,
          })}
        >
          <Group
            onClick={() => collapseNotaToggle.toggle()}
            position='apart'
            py='sm'
            px='lg'

            sx={(tema) => ({
              backgroundColor: tema.colorScheme === 'light' ? (collapseNotaOpened ? 'transparent' : tema.colors.gray[0]) : (collapseNotaOpened ? 'transparent' : tema.colors.dark[6]),
              borderRadius: tema.radius.sm,
              cursor: 'pointer',
            })}
          >
            <Text>Nota</Text>
            {collapseNotaOpened ? <IconChevronUp size='1rem' /> : <IconChevronDown size='1rem' />}
          </Group>

          <Collapse in={collapseNotaOpened} px='sm' py='sm'>
            {canAccessModifyStepNota({ stateObject: { subLevel: loginContext } }) ?
              <StepNota
                stateURI1={URI1}
                stateUtilsRef={utilsRef.current}
                stateIsSequence={true}

                fnRefreshNotaIndex={fnRefreshNotaIndex}
                fnRefreshHistory={() => {
                  setData(d => ({ ...d, triggerRefreshHistory: new Date() }))
                }}

                fnRefreshStepSelesai={() => { }}

                fnClickPhoto={(object) => {
                  setData(d => ({
                    ...d,
                    imageLightboxImages: object.images,
                    imageLightboxTitle: object.title,
                    imageLightboxIndex: object.index,
                    imageLightboxFieldName: object.fieldName,
                    imageLightboxShow: true,
                  }));
                }}

                stateShowMediaQC={true}
                fnClickMediaImageVideo={(object) => {
                  object.type === utils.mediaQCType.image.value ?
                    setData(d => ({
                      ...d,
                      imageLightboxImages: object.images,
                      imageLightboxTitle: object.title,
                      imageLightboxIndex: object.index,
                      imageLightboxFieldName: object.fieldName,
                      imageLightboxShow: true,
                    }))
                    :
                    setData(d => ({
                      ...d,
                      mediaURL: object.name,
                      mediaTitle: object.title,
                      mediaShow: true,
                    }))
                }}

                fnCloseDrawer={fnCloseDrawer}
              />
              :
              <StepNotaDibatalkan
                stateURI1={URI1}
                stateUtilsRef={utilsRef.current}

                fnRefreshNotaIndex={fnRefreshNotaIndex}
                fnRefreshHistory={() => {
                  setData(d => ({ ...d, triggerRefreshHistory: new Date() }))
                }}

                fnClickPhoto={(object) => setData(d => ({
                  ...d,
                  imageLightboxImages: object.images,
                  imageLightboxTitle: object.title,
                  imageLightboxIndex: object.index,
                  imageLightboxFieldName: object.fieldName,
                  imageLightboxShow: true,
                }))}

                stateShowMediaQC={true}
                fnClickMediaImageVideo={(object) => {
                  object.type === utils.mediaQCType.image.value ?
                    setData(d => ({
                      ...d,
                      imageLightboxImages: object.images,
                      imageLightboxTitle: object.title,
                      imageLightboxIndex: object.index,
                      imageLightboxFieldName: object.fieldName,
                      imageLightboxShow: true,
                    }))
                    :
                    setData(d => ({
                      ...d,
                      mediaURL: object.name,
                      mediaTitle: object.title,
                      mediaShow: true,
                    }))
                }}

                fnCloseDrawer={fnCloseDrawer}
              />
            }
          </Collapse>
        </Box>

        <Accordion
          variant="separated"
          defaultValue={[]}

          styles={(tema) => ({
            item: {
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: tema.colorScheme === 'light' ? tema.colors.gray[3] : tema.colors.dark[4],
            },
          })}
        >
          <Accordion.Item value="accordion-history">
            <Accordion.Control>History Project {data.counterHistoryProject ? `(${data.counterHistoryProject})` : ''}</Accordion.Control>
            <Accordion.Panel
              sx={{
                '& .mantine-Accordion-content': {
                  paddingRight: '.25rem',
                  paddingBottom: '.25rem',
                }
              }}
            >
              <HistoryProjectCustomer
                stateURI1={URI1}
                stateUtilsRef={utilsRef.current}
                fnCounter={fnCounter}
                stateData={{
                  refresh: data.triggerRefreshHistory
                }}
              />
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>

        <Box mt='sm' />

        <StepPengerjaan
          stateData={{
            projectId: URI1,

            projectProcess: utilsRef.current.projectProcess,
            projectIsCancel: utilsRef.current.projectIsCancel,
            userAccess: utilsRef.current.userAccess,
          }}

          stateShowNextComponent={true}

          fnClickPhoto={(object) => {
            setData(d => ({
              ...d,
              imageLightboxImages: object.images,
              imageLightboxTitle: object.title,
              imageLightboxIndex: object.index,
              imageLightboxFieldName: object.fieldName,
              imageLightboxShow: true,
            }))
          }}

          fnCloseDrawer={fnCloseDrawer}

          fnSuccessTakesThisProject={fnSuccessTakesThisProject}
        />
      </Drawer>

      <ImageLightBox2
        stateImages={Array.isArray(data.imageLightboxImages) && (data.imageLightboxImages.length > 0) ? data.imageLightboxImages.map(key => ROOT_BASE_URL + key[data.imageLightboxFieldName]) : []}

        stateTitle={data.imageLightboxTitle}
        stateSelectedIndex={data.imageLightboxIndex}
        stateShow={data.imageLightboxShow}
        fnShow={() => setData(d => ({ ...d, imageLightboxShow: false }))}
      />

      <VideoPlayerModal
        stateURL={data.mediaURL}
        stateTitle={data.mediaTitle}
        stateShow={data.mediaShow}
        fnShow={() => setData(d => ({ ...d, mediaShow: false }))}
      />

      <FeedbackDrawer
        stateShow={data.feedbackModal}
        fnShow={(val) => setData(d => ({ ...d, feedbackModal: val }))}
        stateData={{
          data: stateData.data,
        }}
        fnShouldUpdateIndex={fnRefreshNotaIndex}
      />
    </React.Fragment>
  )
}

export default React.memo(ProjectPengerjaanSelected);